class LeoShopByCollections extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.tabButtons = this.querySelectorAll('.tab-btn');
    this.tabPanels = this.querySelectorAll('.tab-panel');

    this.tabButtons.forEach((button) => {
      button.addEventListener('click', (e) => this.switchTab(e));
    });
  }

  switchTab(event) {
    const targetTab = event.target.getAttribute('data-tab');

    // Remove active class from all tabs and panels
    this.tabButtons.forEach((btn) => btn.classList.remove('active'));
    this.tabPanels.forEach((panel) => panel.classList.remove('active'));

    // Set active class on selected tab and panel
    event.target.classList.add('active');
    this.querySelector(`#${targetTab}`).classList.add('active');
  }

  connectedCallback() {
    this.init();
  }
}

// Register the custom element
customElements.define('leo-shop-by-collections', LeoShopByCollections);
